import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleContactCreditViewDialogTourConfig: AgTechTourConfig = {
    id: 'contact-credit-view-dialog-tour',
    name: 'Credits Overview Tour',
    steps: [
        {
            targetId: 'contact-credits-view',
            title: 'Contact Credits',
            description: 'Review the credits this contact currently has.',
            position: 'top',
        },
    ]
}
